module.exports = __webpack_public_path__ + "img/comm_session_bg.492676f0.svg";